// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-lista-procedimentos-associados {
    margin-top: 30px;
    padding: 20px 20px 20px 0px;
    background-color: #f4f4f4; /* Cor sutil para o fundo */
    border-radius: 10px; /* Bordas arredondadas para o container */
}

.my-lista-procedimentos-associados-h2 {
    margin-bottom: 20px;
    font-size: 1.5rem; /* Melhor ajuste do tamanho da fonte */
    font-weight: 500;
    color: #333; /* Cor mais visível para o texto */
}

.my-lista-procedimentos-associados-cards {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 200px;
    overflow-y: auto;
    gap: 20px;
    border: 1px solid #ddd;
    background-color: whitesmoke;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0 2px 8px inset rgba(0, 0, 0, 0.1); /* Sombra leve no container */
    align-items: center;
}

.my-lista-procedimentos-associados-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff; /* Mantém o fundo claro */
    border: 1px solid #ddd; /* Borda sutil */
    border-radius: 8px;
    width: 100%;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Sombra suave */
    transition: transform 0.3s ease, box-shadow 0.3s ease; /* Suaviza animação */
}

.my-lista-procedimentos-associados-card:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Intensifica a sombra ao passar o mouse */
}

.my-lista-procedimentos-associados-card h5 {
    display: inline-block;
    max-width: 500px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    font-size: 1rem; /* Tamanho adequado para texto */
    font-weight: 500;
    color: #555; /* Cor neutra para o texto */
    transition: color 0.2s ease; /* Animação de mudança de cor */
}

.my-lista-procedimentos-associados-card h5:hover {
    text-overflow: clip;
    white-space: normal;
    color: #007BFF; /* Cor de destaque ao passar o mouse */
}

.my-lista-procedimentos-associados-p {
    margin-top: 20px;
    font-size: 0.9rem; /* Ajusta o tamanho da fonte */
    color: #666; /* Tom sutil para o texto */
    line-height: 1.5; /* Melhor espaçamento entre linhas */
}

/* Adição de um estilo de scrollbar para uma aparência mais personalizada */
.my-lista-procedimentos-associados-cards::-webkit-scrollbar {
    width: 8px;
}

.my-lista-procedimentos-associados-cards::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 4px;
}

.my-lista-procedimentos-associados-cards::-webkit-scrollbar-thumb:hover {
    background-color: #aaa;
}

.my-lista-procedimentos-associados-cards::-webkit-scrollbar-track {
    background-color: #f4f4f4;
}
`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ListaProcedimentosAssociados.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,yBAAyB,EAAE,2BAA2B;IACtD,mBAAmB,EAAE,yCAAyC;AAClE;;AAEA;IACI,mBAAmB;IACnB,iBAAiB,EAAE,sCAAsC;IACzD,gBAAgB;IAChB,WAAW,EAAE,kCAAkC;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,4BAA4B;IAC5B,mBAAmB;IACnB,aAAa;IACb,8CAA8C,EAAE,6BAA6B;IAC7E,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB,EAAE,yBAAyB;IACjD,sBAAsB,EAAE,gBAAgB;IACxC,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,wCAAwC,EAAE,iBAAiB;IAC3D,qDAAqD,EAAE,qBAAqB;AAChF;;AAEA;IACI,sBAAsB;IACtB,yCAAyC,EAAE,2CAA2C;AAC1F;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,eAAe,EAAE,gCAAgC;IACjD,gBAAgB;IAChB,WAAW,EAAE,4BAA4B;IACzC,2BAA2B,EAAE,+BAA+B;AAChE;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,cAAc,EAAE,sCAAsC;AAC1D;;AAEA;IACI,gBAAgB;IAChB,iBAAiB,EAAE,8BAA8B;IACjD,WAAW,EAAE,2BAA2B;IACxC,gBAAgB,EAAE,oCAAoC;AAC1D;;AAEA,2EAA2E;AAC3E;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".my-lista-procedimentos-associados {\n    margin-top: 30px;\n    padding: 20px 20px 20px 0px;\n    background-color: #f4f4f4; /* Cor sutil para o fundo */\n    border-radius: 10px; /* Bordas arredondadas para o container */\n}\n\n.my-lista-procedimentos-associados-h2 {\n    margin-bottom: 20px;\n    font-size: 1.5rem; /* Melhor ajuste do tamanho da fonte */\n    font-weight: 500;\n    color: #333; /* Cor mais visível para o texto */\n}\n\n.my-lista-procedimentos-associados-cards {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    max-height: 200px;\n    overflow-y: auto;\n    gap: 20px;\n    border: 1px solid #ddd;\n    background-color: whitesmoke;\n    border-radius: 10px;\n    padding: 20px;\n    box-shadow: 0 2px 8px inset rgba(0, 0, 0, 0.1); /* Sombra leve no container */\n    align-items: center;\n}\n\n.my-lista-procedimentos-associados-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #fff; /* Mantém o fundo claro */\n    border: 1px solid #ddd; /* Borda sutil */\n    border-radius: 8px;\n    width: 100%;\n    padding: 15px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Sombra suave */\n    transition: transform 0.3s ease, box-shadow 0.3s ease; /* Suaviza animação */\n}\n\n.my-lista-procedimentos-associados-card:hover {\n    transform: scale(1.05);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2); /* Intensifica a sombra ao passar o mouse */\n}\n\n.my-lista-procedimentos-associados-card h5 {\n    display: inline-block;\n    max-width: 500px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    cursor: pointer;\n    font-size: 1rem; /* Tamanho adequado para texto */\n    font-weight: 500;\n    color: #555; /* Cor neutra para o texto */\n    transition: color 0.2s ease; /* Animação de mudança de cor */\n}\n\n.my-lista-procedimentos-associados-card h5:hover {\n    text-overflow: clip;\n    white-space: normal;\n    color: #007BFF; /* Cor de destaque ao passar o mouse */\n}\n\n.my-lista-procedimentos-associados-p {\n    margin-top: 20px;\n    font-size: 0.9rem; /* Ajusta o tamanho da fonte */\n    color: #666; /* Tom sutil para o texto */\n    line-height: 1.5; /* Melhor espaçamento entre linhas */\n}\n\n/* Adição de um estilo de scrollbar para uma aparência mais personalizada */\n.my-lista-procedimentos-associados-cards::-webkit-scrollbar {\n    width: 8px;\n}\n\n.my-lista-procedimentos-associados-cards::-webkit-scrollbar-thumb {\n    background-color: #ccc;\n    border-radius: 4px;\n}\n\n.my-lista-procedimentos-associados-cards::-webkit-scrollbar-thumb:hover {\n    background-color: #aaa;\n}\n\n.my-lista-procedimentos-associados-cards::-webkit-scrollbar-track {\n    background-color: #f4f4f4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
